import { useCallback, useState } from 'react';

import { useApolloClient } from 'state/graphql/hooks/use-sanity-query';
import { useSanityGqlEndpoint } from 'utils/network';

import {
  IMergePersonalizedData,
  fetchPersonalizedOfferData as fetchData,
} from './utils/personalized-offers';

export const usePersonalizedOffers: () => [
  () => Promise<
    Omit<IMergePersonalizedData, 'validOffer' | 'transformSmartBlockContent' | 'engineOffer'>
  >,
  { loading: boolean }
] = () => {
  const [loading, setLoading] = useState(false);

  const client = useApolloClient();
  const uri = useSanityGqlEndpoint();

  const fetchPersonalizedOfferData = useCallback(async () => {
    setLoading(true);

    return fetchData({ client, uri }).then(data => {
      setLoading(false);

      return data;
    });
  }, [setLoading, client, uri]);

  return [fetchPersonalizedOfferData, { loading }];
};
